import { DownloadFile, enqueueSnackbar, UploadFile } from 'actions';
import {
	GetIncidentsRequest,
	GetIncidentDetailsRequest,
	GetIncidentDropdownsRequest,
	EditIncidentDetailsRequest,
	CreateIncidentRequest,
	DeleteIncidentRequest,
	ExportIncidentsRequest,
	GetAutocompleteFieldsRequest,
	AddAttachmentRequest,
	DownloadAttachmentRequest,
	RemoveAttachmentRequest,
	GetCommentsRequest,
	AddCommentRequest,
	AddDropdownFieldRequest,
	RemoveDropdownFieldRequest
} from '../requests/IncidentTrackerRequests';

export const SET_FORM_STATE = 'SET_FORM_STATE';
export const RESET_FIELDS = 'RESET_FIELDS';
export const GET_INCIDENT_TRACKER_TRACKER = 'GET_INCIDENT_TRACKER_TRACKER';
export const TOGGLE_INCIDENT_TRACKER_DIALOG = 'TOGGLE_INCIDENT_TRACKER_DIALOG';
export const GET_INCIDENT_TRACKER_TRACKER_DETAILS = 'GET_INCIDENT_TRACKER_TRACKER_DETAILS';
export const GET_INCIDENT_TRACKER_TRACKER_DROPDOWNS = 'GET_INCIDENT_TRACKER_TRACKER_DROPDOWNS';
export const TOGGLE_DELETE_INCIDENT_TRACKER_DIALOG = 'TOGGLE_DELETE_INCIDENT_TRACKER_DIALOG';
export const GET_INCIDENT_TRACKER_AUTOCOMPLETE = 'GET_INCIDENT_TRACKER_AUTOCOMPLETE';
export const TOGGLE_ATTACH_FILE_INCIDENT_TRACKER_DIALOG = 'TOGGLE_ATTACH_FILE_INCIDENT_TRACKER_DIALOG';
export const TOGGLE_REMOVE_FILE_INCIDENT_TRACKER_DIALOG = 'TOGGLE_REMOVE_FILE_INCIDENT_TRACKER_DIALOG';
export const TOGGLE_OPTIONS_INCIDENT_TRACKER_DIALOG = 'TOGGLE_OPTIONS_INCIDENT_TRACKER_DIALOG';
export const TOGGLE_OPTIONS_INCIDENT_TRACKER_FORM = 'TOGGLE_OPTIONS_INCIDENT_TRACKER_FORM';
export const GET_COMMENTS = 'GET_COMMENTS';
export const ADD_DROPDOWN_FIELD = 'ADD_DROPDOWN_FIELD';

const onSetFormState = value => ({
	type: SET_FORM_STATE,
	formState: value
});

const onResetFields = () => ({
	type: RESET_FIELDS
});

const onGetIncidents = value => ({
	type: GET_INCIDENT_TRACKER_TRACKER,
	incidents: value
});

const onToggleIncidentTrackerDialog = (visible, tableId) => ({
	type: TOGGLE_INCIDENT_TRACKER_DIALOG,
	visible,
	tableId
});

const onGetIncidentDetails = value => ({
	type: GET_INCIDENT_TRACKER_TRACKER_DETAILS,
	incidentDetails: value
});

const onGetIncidentDropdowns = value => ({
	type: GET_INCIDENT_TRACKER_TRACKER_DROPDOWNS,
	dropdowns: value
});

const onToggleDeleteIncidentTrackerDialog = (visible, tableId) => ({
	type: TOGGLE_DELETE_INCIDENT_TRACKER_DIALOG,
	visible,
	tableId
});

const onGetAutocompleteFields = value => ({
	type: GET_INCIDENT_TRACKER_AUTOCOMPLETE,
	autocompleteFields: value
});

const onToggleAttachFileIncidentTrackerDialog = visible => ({
	type: TOGGLE_ATTACH_FILE_INCIDENT_TRACKER_DIALOG,
	visible
});

const onToggleRemoveFileIncidentTrackerDialog = visible => ({
	type: TOGGLE_REMOVE_FILE_INCIDENT_TRACKER_DIALOG,
	visible
});

const onToggleOptionsIncidentTrackerDialog = visible => ({
	type: TOGGLE_OPTIONS_INCIDENT_TRACKER_DIALOG,
	visible
});

const onToggleOptionsIncidentTrackerForm = (visible, dropdownLabel, dropdownName, dropdownValue, dropdownId) => ({
	type: TOGGLE_OPTIONS_INCIDENT_TRACKER_FORM,
	visible,
	dropdownLabel,
	dropdownName,
	dropdownValue,
	dropdownId
});

const onGetComments = value => ({
	type: GET_COMMENTS,
	comments: value
});

const onAddDropdownField = value => ({
	type: ADD_DROPDOWN_FIELD,
	newDropdownField: value
});

export const SetFormState = value => dispatch => {
	dispatch(onSetFormState(value));
};

export const ResetFields = () => dispatch => {
	dispatch(onResetFields());
};

export const GetIncidents = (userId, role) => async dispatch => {
	await GetIncidentsRequest(userId, role)
		.then(response => {
			dispatch(onGetIncidents(response.data));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const ToggleIncidentTrackerDialog = (visible, tableId) => dispatch => {
	dispatch(onToggleIncidentTrackerDialog(visible, tableId));
};

export const GetIncidentDetails = (
	userId,
	tableId
) => async dispatch => {
	await GetIncidentDetailsRequest(userId, tableId)
		.then(response => {
			dispatch(onGetIncidentDetails(response.data));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const GetIncidentDropdowns = (
	userId,
	tableId
) => async dispatch => {
	await GetIncidentDropdownsRequest(userId, tableId)
		.then(response => {
			dispatch(onGetIncidentDropdowns(response.data));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const EditIncidentDetails = incidentTrackerDto => async dispatch => {
	await EditIncidentDetailsRequest(incidentTrackerDto)
		.then(response => {
			dispatch(GetIncidents());
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const CreateIncident = incidentTrackerDto => async dispatch => {
	await CreateIncidentRequest(incidentTrackerDto)
		.then(response => {
			dispatch(GetIncidents());
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const ToggleDeleteIncidentTrackerDialog = (visible, tableId) => dispatch => {
	dispatch(onToggleDeleteIncidentTrackerDialog(visible, tableId));
};

export const DeleteIncident = (userId, tableId) => async dispatch => {
	await DeleteIncidentRequest(userId, tableId)
		.then(response => { })
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const ExportIncidents = (userId, role) => async dispatch => {
	await ExportIncidentsRequest(userId, role)
		.then(response => {
			dispatch(DownloadFile(response.data));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const GetAutocompleteFields = siteId => async dispatch => {
	await GetAutocompleteFieldsRequest(siteId)
		.then(response => {
			dispatch(onGetAutocompleteFields(response.data));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const AddAttachment = (
	userId,
	incidentId,
	filePath
) => async dispatch => {
	await AddAttachmentRequest(userId, incidentId, filePath)
		.then(response => {
			// dispatch(GetRepositoryFiles());
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const UploadAttachment = (
	userId,
	incidentId,
	file
) => async dispatch => {
	await UploadFile(file)
		.then(response => {
			dispatch(AddAttachment(userId, incidentId, response.data));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const ToggleAttachFileIncidentTrackerDialog = visible => dispatch => {
	dispatch(onToggleAttachFileIncidentTrackerDialog(visible));
};

export const DownloadAttachment = (userId, tableId) => async dispatch => {
	await DownloadAttachmentRequest(userId, tableId)
		.then(response => {
			dispatch(DownloadFile(response.data));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const ToggleRemoveFileIncidentTrackerDialog = visible => dispatch => {
	dispatch(onToggleRemoveFileIncidentTrackerDialog(visible));
};

export const ToggleOptionsIncidentTrackerDialog = visible => dispatch => {
	dispatch(onToggleOptionsIncidentTrackerDialog(visible));
};

export const ToggleOptionsIncidentTrackerForm = (visible, dropdownLabel, dropdownName, dropdownValue, dropdownId) => dispatch => {
	dispatch(onToggleOptionsIncidentTrackerForm(visible, dropdownLabel, dropdownName, dropdownValue, dropdownId));
};

export const RemoveAttachment = (userId, tableId) => async dispatch => {
	await RemoveAttachmentRequest(userId, tableId)
		.then(response => {
			// dispatch(DownloadFile(response.data));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const GetComments = id => async dispatch => {
	await GetCommentsRequest(id)
		.then(response => {
			dispatch(onGetComments(response.data));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const AddComment = (trackerCommentDto) => async dispatch => {
	await AddCommentRequest(trackerCommentDto)
		.then(response => {
			dispatch(GetComments(trackerCommentDto.tableId));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const AddDropdownField = (userId, name, value, relations) => async dispatch => {
	await AddDropdownFieldRequest(userId, name, value, relations)
		.then(response => {
			dispatch(GetIncidentDropdowns());
			dispatch(onAddDropdownField(response.data));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const RemoveDropdownField = (userId, name, value, id, relations) => async dispatch => {
	await RemoveDropdownFieldRequest(userId, name, value, id, relations)
		.then(response => {
			dispatch(GetIncidentDropdowns());
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};
